// GENERATED — do not edit. Source: shared/brand/CorosLogo.jsx. Run sync-brand.sh.
// COROS hexagon mark (primary logo per VI 2023) + configurable app wordmark.
// Copy into any COROS internal build. Pass `app` to set the sub-wordmark.
//   <CorosLogo app="SCOUT" />   <CorosLogo app="PULSE" size={30} />
//   <CorosLogo />               (mark + COROS only)

export function Hex({ size = 26, color = 'var(--coros-red)' }) {
  return (
    <svg width={size} height={size * (90 / 80)} viewBox="0 0 80 90" fill="none" aria-hidden="true">
      <path d="M8.51057 57.5325L35.7814 73.2262L63.4134 61.5063V67.1184L32.3368 84.9965L0 66.3875V30.6229L5.04921 27.4976L8.50216 57.5241L8.51057 57.5325ZM47.8961 11.7955L20.6673 27.5648L17.0043 57.356L12.14 54.55L12.1904 18.7014L44.4768 0L75.4441 17.8781L75.6206 23.8178L47.8877 11.7955H47.8961ZM67.7989 69.1095L67.7569 37.6465L43.7878 19.5752L48.6522 16.7691L79.67 34.7396L79.7204 72.05L48.753 89.9281L43.519 87.1136L67.7989 69.1095Z" fill={color} />
    </svg>
  );
}

export function CorosLogo({ size = 26, app = null }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <Hex size={size} />
      <div style={{ lineHeight: 1 }}>
        <div style={{
          fontFamily: 'var(--display)', fontWeight: 900, letterSpacing: '.06em',
          fontSize: size * 0.62, color: 'var(--text)'
        }}>COROS</div>
        {app && (
          <div style={{
            fontFamily: 'var(--display)', fontWeight: 700, letterSpacing: '.28em',
            fontSize: size * 0.30, color: 'var(--coros-red)', marginTop: 2
          }}>{app}</div>
        )}
      </div>
    </div>
  );
}

export default CorosLogo;
